module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_gaseosas_pet_500_ccsa.cdea8420.png";